import { render, staticRenderFns } from "./EmptyTaxIcon.vue?vue&type=template&id=a3896164"
import script from "./EmptyTaxIcon.vue?vue&type=script&lang=js"
export * from "./EmptyTaxIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports